import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import formatTimestamp from '../../../i18n/formatTimestamp';

import '../../../ecs/components/analytics/PerformanceFlyout.scss';
import { ANALYTICS_COLORS } from '../../../ecs/constants';

class ExperimentPerformanceFlyout extends Component {
  getI18nID(suffix) {
    return `components.experiment.performance.results.flyOut.${suffix}`;
  }

  renderTooltip(data) {
    const { formatNumber } = this.props.intl;

    const timestamp = formatTimestamp(this.props.intl)(data.timestamp);
    return (
      <div className="chart-tooltip">
        <div className="chart-tooltip-header">
          <div className="chart-text-with-label">
            <p>
              <FormattedMessage id="components.ecs.analytics.perf.details.date" />
            </p>
            <p>{timestamp}</p>
          </div>
          <div className="chart-text-with-label">
            <p>
              <FormattedMessage id="components.ecs.analytics.perf.details.total" />
            </p>
            <p>{data.selections_total}</p>
          </div>
        </div>
        <div className="chart-tooltip-table">
          <div className="chart-tooltip-row chart-table-header">
            <div className="asset-cell">
              <FormattedMessage id={this.getI18nID('nrOfAssets')} />
            </div>
            <div className="selection-cell">
              <FormattedMessage id={this.getI18nID('selections')} />
            </div>
            {this.props.chartType === 'ctor' ? (
              <div className="ctor-cell">
                <FormattedMessage id={this.getI18nID('ctor')} />
              </div>
            ) : (
              <div className="click-cell">
                <FormattedMessage id={this.getI18nID('clicks')} />
              </div>
            )}
          </div>
          {data.performers.slice(0, 10).map((performer, idx) => {
            const notPerformer =
              this.props.chartType === 'ctor'
                ? new RegExp(
                    performer.name + '","selections":0,"clicks":\\d+,"ctor":0}'
                  )
                : new RegExp(
                    performer.name + '","selections":0,"clicks":0,"ctor":\\d+}'
                  );
            const performing =
              JSON.stringify(performer.slice).match(notPerformer) === null;
            if (performing) {
              const truncKey =
                performer.name.length >= 10
                  ? `${performer.name.substr(0, 9)}...`
                  : performer.name;
              const selections_total = data.selections_total || 0;
              const selections = performer.slice.selections || 0;
              const clicks_total = data.clicks_total || 0;
              const clicks = performer.slice.clicks || 0;
              const ctor = performer.slice.ctor || 0;
              const selectionPercent = selections / selections_total || 0;
              const clickPercent = clicks / clicks_total || 0;
              return (
                <div
                  className="chart-tooltip-row"
                  key={`chart-tooltip-row-${idx}`}
                >
                  <div className="asset-cell">
                    <div
                      className="asset-cell-stripe"
                      style={{ backgroundColor: ANALYTICS_COLORS[idx] }}
                    />
                    <div
                      className="asset-cell-thumbnail"
                      style={{
                        backgroundImage: `url(${performer.image_url})`
                      }}
                    />
                    <div className="asset-cell-key">{truncKey}</div>
                  </div>
                  <div className="selection-cell">
                    {selections} (
                    {formatNumber(selectionPercent, {
                      style: 'percent',
                      maximumFractionDigits: 1
                    })}
                    )
                  </div>
                  {this.props.chartType === 'ctor' ? (
                    <div className="ctor-cell">
                      {formatNumber(ctor, {
                        style: 'percent',
                        maximumFractionDigits: 3
                      })}
                    </div>
                  ) : (
                    <div className="click-cell">
                      {clicks} (
                      {formatNumber(clickPercent, {
                        style: 'percent',
                        maximumFractionDigits: 1
                      })}
                      )
                    </div>
                  )}
                </div>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  }

  render() {
    const { x } = this.props;
    let performing = this.props.data[this.props.datum.xName].performers.filter(
      function(perf) {
        return (
          perf.slice.selections !== 0 ||
          perf.slice.clicks !== 0 ||
          perf.slice.ctor !== 0
        );
      }
    );

    const performer_count = performing.length;
    // if the tooltip doesn't have enough room to the right, draw it on the left instead
    const newX = window.innerWidth - x >= 400 ? x + 50 : x - 450;
    const newY =
      performer_count < 6 ? performer_count * -10 : performer_count * -25;
    return (
      <g style={{ pointerEvents: 'none' }}>
        <foreignObject x={newX} y={newY} width="400" height="600">
          <div xmlns="http://www.w3.org/1999/xhtml">
            {this.renderTooltip(this.props.data[this.props.datum.xName])}
          </div>
        </foreignObject>
      </g>
    );
  }
}

ExperimentPerformanceFlyout.propTypes = {
  chartType: PropTypes.string,
  performers: PropTypes.array
};
export default injectIntl(ExperimentPerformanceFlyout);
